module.exports = __webpack_public_path__ + "static/media/php.5f4952d8.svg";